import { AiFillStar,AiOutlineStar } from "react-icons/ai";

function Stars(stars){
    const arr = [1,2,3,4,5]

    if(stars.stars===null){
        return null;
    }

    return(
        <>
            {
                (stars.stars!==0 && stars.stars!=="0") ? 
                <ul className="list-inline mb-0">
                    {
                        arr.map((item, i)=>(
                            <li className="list-inline-item" key={i}>
                                {
                                    item <= parseInt(stars.stars) ? <AiFillStar className="stars-on"/> : <AiOutlineStar />
                                }                        
                            </li>
                        ))
                    }
                </ul> :
                <ul className="list-inline mb-0">
                    <li className="list-inline-item"><AiFillStar className="stars-off"/></li>
                    <li className="list-inline-item"><AiFillStar className="stars-off"/></li>
                    <li className="list-inline-item"><AiFillStar className="stars-off"/></li>
                    <li className="list-inline-item"><AiFillStar className="stars-off"/></li>
                    <li className="list-inline-item"><AiFillStar className="stars-off"/></li>
                </ul>
            }
        </>        
    )
}

export default Stars